import React from "react";
import { Button, useMediaQuery, useTheme } from "@mui/material";
import { motion } from "framer-motion";
import { useNavigate, useLocation } from "react-router-dom";

const FloatingQuoteButton = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"), { noSsr: true });

  if (location.pathname === "/get-a-quote") return null;

  return (
    <motion.div
      initial={{ opacity: 0, x: isMobile ? 0 : 50, scale: isMobile ? 0.8 : 1 }}
      animate={{ opacity: 1, x: 0, scale: 1 }}
      transition={{ duration: 0.35 }}
      style={{
        position: "fixed",
        bottom: isMobile ? 16 : 24,
        right: isMobile ? 16 : 24,
        zIndex: 999,
      }}
    >
      <Button
        variant="contained"
        color="secondary"
        onClick={() => navigate("/get-a-quote")}
        sx={{
          borderRadius: "50px",
          px: isMobile ? 2.5 : 4,
          py: isMobile ? 0.75 : 1.5,
          fontSize: isMobile ? "0.85rem" : "1rem",
          fontWeight: "bold",
          boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
          textTransform: "none",
        }}
      >
        {isMobile ? "Quote" : "Get a Quote"}
      </Button>
    </motion.div>
  );
};

export default FloatingQuoteButton;
